import { useSelector } from 'react-redux';
import { rootApi } from '../../services/rootApi';

/**
 * useIsMutationPending
 * Generic hook to check if any RTK Query mutation matching the predicate or endpointName is pending.
 *
 * Usage examples:
 *  - const isPending = useIsMutationPending('sendInvitations');
 *  - const isAnyPending = useIsMutationPending((m) => m.endpointName?.startsWith('users'));
 */
export const useIsMutationPending = (predicateOrEndpointName) => {
  return useSelector((state) => {
    const apiState = state[rootApi.reducerPath];
    const mutations = apiState?.mutations || {};

    const predicate = typeof predicateOrEndpointName === 'function'
      ? predicateOrEndpointName
      : (m) => m?.endpointName === predicateOrEndpointName;

    return Object.values(mutations).some(
      (m) => predicate(m) && m?.status === 'pending'
    );
  });
};

/**
 * useAnyMutationPending
 * Convenience helper to check if any of the provided endpoint names are pending.
 */
export const useAnyMutationPending = (endpointNames = []) => {
  return useIsMutationPending((m) => endpointNames.includes(m?.endpointName));
};

